import URI from 'urijs'
import { API_BASE } from '../../../shared/constants/Api'

export const RULES_LIST = (params) => { return URI(`${API_BASE}/api/v2/rules/`).addSearch(params) }
export const RULE = ({id, ...params}) => { return URI(`${API_BASE}/api/v2/rules/${id}/`).addSearch(params) }
export const PREVIEW_INVOICES = (params) => { return URI(`${API_BASE}/api/v2/rules/preview_source_documents/`).addSearch(params) }
